import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EmployeeService } from '../employee.service';
import {HttpResponse, HttpEventType } from '@angular/common/http';
import { Observable,Subject } from "rxjs";
import {MatTableDataSource,MatPaginator} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import * as XLSX from 'xlsx';
import { NullTemplateVisitor } from '@angular/compiler';
import { parseJSON } from 'jquery';
import { Config } from 'protractor';

export interface Inventory {
  itemId: string;
  description: string;
  um : string;
  maxextcost: number;
  maxqty: number;
  cost : number;
  threeMonthUsage: number;
  utilization: number;
  name: string;
}

@Component({
  selector: 'app-inventory-assign',
  templateUrl: './inventory-assign.component.html',
  styleUrls: ['./inventory-assign.component.css']
})
export class InventoryAssignComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  displayedColumns: string[] = ['select', 'itemid','description', 'um','maxqty', 'cost','threeMonthUsage','utilization','name' ];
  dataSource = new MatTableDataSource<Inventory>();
  selection = new SelectionModel<Inventory>(true, []);
  maxall : number=20;
  name: any=null;
  itemid: any=null;

  selectedFiles: FileList;
  currentFile: File;
  progress = 0;
  message = '';
  empname : any=null;
  employees: any = [];
  selectedOwner: any=null;
  newOwner: any=null;
  newEmpList: any = [];
  resMessage:string = '';
  closeAlertMessage: boolean = false;

  applyFilter(name: string,itemid) {
      this.dataSource.filter = name + "," + itemid;
  }
  constructor(private employeeservice:EmployeeService) {
    this.selectedOwner = '';
    this.newOwner = '';
    this.resMessage = '';
    this.closeAlertMessage = false;
  }

  ngOnInit() {
    this.employeeservice.getEmployeeList().subscribe(data =>{
      this.employees =data;
      this.newEmpList = data;
    });

    this.dataSource.paginator = this.paginator;
   /* this.employeeservice.getInventoryList()
      .subscribe(res => {
        this.dataSource.data = res as Inventory[];
        console.log(res)
      }) */
      this.dataSource.filterPredicate = this.customFiltered();
      this.name="";
      this.itemid="";
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource.paginator.length>this.maxall)
    return [10, 20, 30,  this.dataSource.paginator.length];
    else
    return [10, 20, 30, this.maxall];
    }

  customFiltered() {
    return (data, filter) => {
      if (this.name)
        return data.name == this.name
        return true
        if (this.itemid)
        return data.itemid == this.itemid
        return true
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
  logSelection() {
    this.selection.selected.forEach(s => console.log(s.itemId));
  }

 hideMessage() {
  this.closeAlertMessage = false;
 }
   save(){
     const arr:any = this.selection.selected.map(o => o.itemId);
     this.employeeservice.updateInventryAssign(this.newOwner, arr).subscribe(
      (res: Config) => {
         if(res.status == 200) {
          this.message = 'Inventory assigned successfully!';
          this.closeAlertMessage = true;
          this.dataSource.data = [];
          this.selection.clear();
       //   this.getUserInvertry(this.selectedOwner);
          this.selectedOwner = '';
          this.newOwner = '';
         }
       }
     )

     /*console.log('hello' +this.name);
     console.log(this.itemid);
     this.employeeservice.removeInvByNameItem(this.name,this.itemid)
      .subscribe(
        data => {
          console.log(data);
        })*/
   }
   cancel(){
    this.refresh();
  }
exportToExcel() {
  let dataToExport = this.selection.selected
    .map(x => ({
      itemid: x.itemId,
      description: x.description,
      um: x.um,
      maxqty: x.maxqty,
      maxextcost: x.maxextcost,
      cost: x.cost,
      threeMonthUsage: x.threeMonthUsage,
      utilization: x.utilization
      }));

  let workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, <XLSX.Table2SheetOpts>{ sheet: 'Sheet 1' });
  let workBook: XLSX.WorkBook = XLSX.utils.book_new();

  // Adjust column width
  var wscols = [
    { wch: 50 },
    { wch: 50 },
    { wch: 30 }
  ];

  workSheet["!cols"] = wscols;

  XLSX.utils.book_append_sheet(workBook, workSheet, 'TSC_Inv');
  XLSX.writeFile(workBook, 'TSC_Inv.xlsx');
}

selectFile(event): void {
  this.selectedFiles = event.target.files;
}
selectemp(event): void {
  this.empname = event.target.value;
}

upload(): void {
  this.progress = 0;

  console.log('hello' +this.empname);
  this.currentFile = this.selectedFiles.item(0);
  this.employeeservice.uploadAssignment(this.currentFile,this.empname).subscribe(
    event => {
      if (event.type === HttpEventType.UploadProgress) {
        this.progress = Math.round(100 * event.loaded / event.total);
        console.log(`Uploaded! ${this.progress}%`);
      }
      else if (event instanceof HttpResponse) {
        this.message = 'File Uploaded Succesfuly!';
        this.refresh();
      }
    },
    err => {
      this.progress = 0;
      this.message = 'Could not upload the file!';
      this.currentFile = undefined;
    });

  this.selectedFiles = undefined;
}

refresh(): void {
  window.location.reload();
}

applyFilterOwner(id: string) {
  this.closeAlertMessage = false;
  this.getUserInvertry(id);
  this.newEmpList = [];
  this.newEmpList = this.employees.filter(function(el) { return el.empId != id; });
  this.newOwner = '';
  this.dataSource.data = [];
  this.selection.clear();
}
  getUserInvertry(id: string) {
    this.employeeservice.getInventoryListNew(id)
      .subscribe(res => {
        this.dataSource.data = res as Inventory[];
      })
  }
}
